'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _downloadPage = require('./download-page');

var _downloadPage2 = _interopRequireDefault(_downloadPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _downloadPage2['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/download-page/index.js
 ** module id = 1191
 ** module chunks = 0
 **/